import type { ApiPresignedFileUpload } from '#/api/s3File/types/ApiPresignedFileUpload';
import type { ApiFileUploadType } from '#/api/types/ApiFileUploadType';
import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import { postJson } from '#/utils/http/postJson';

type Args = {
  embedSearchWidgetId: ApiEmbedSearchWidgetId;
  file: File;
  fileType: ApiFileUploadType;
};

export async function embedSearchWidgetApiCreatePresignedS3FileUpload({
  embedSearchWidgetId,
  file,
  fileType,
}: Args) {
  return postJson<ApiPresignedFileUpload>(
    `/data/embed-search-widgets/${embedSearchWidgetId}/files`,
    {
      fileType,
      filename: file.name,
      size: file.size, // bytes
      mimeType: file.type,
    },
  );
}
